module.exports = __webpack_public_path__ + "img/degreeLineGreenIcon.9267eef1.png";